import { render, staticRenderFns } from "./SDS-Oil.vue?vue&type=template&id=750396aa&scoped=true&"
import script from "./SDS-Oil.vue?vue&type=script&lang=js&"
export * from "./SDS-Oil.vue?vue&type=script&lang=js&"
import style0 from "./SDS-Oil.vue?vue&type=style&index=0&id=750396aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750396aa",
  null
  
)

export default component.exports